import { clientConfig } from 'config/client';
import { Api } from 'core/api';
import localStorage from 'core/local-storage/localStorage';

const mockLoginApi = new Api({
  options: {
    method: 'POST',
  },
  url: '/auth/sign-in',
});

const mockLogin = async (username: string) => {
  const result = await mockLoginApi.simpleFetch({
    options: {
      body: JSON.stringify({
        password: username,
        username,
      }),
    },
  });

  const { accessToken } = result;
  if (!accessToken) {
    throw new Error('access token is corrupted');
  }
  localStorage.set(clientConfig.tokenParamName, accessToken);
};

const eagleFetchJwtApi = new Api({
  options: {
    method: 'POST',
  },
  url: '/eagle-auth/auth',
  useEagleApi: true,
});

const fetchEagleJwt = async (authCode: string) => {
  const result = await eagleFetchJwtApi.simpleFetch({
    options: {
      body: JSON.stringify({
        authCode,
        redirectUri: `${clientConfig.apiPath}/auth/google/callback`,
      }),
    },
  });

  const { token } = result;
  if (!token) {
    throw new Error('access token is corrupted');
  }

  localStorage.set(clientConfig.tokenParamName, token);
};

export { fetchEagleJwt, mockLogin };
